import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { isMfaPending, mfaRedirectPath } from "@/lib/auth/jwt";

interface GuestGuardProps {
  children: React.ReactNode;
}

const MFA_PATHS = ["/auth/mfa/challenge", "/auth/mfa/enroll"];

export function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isTokenExpired, accessToken } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated && !isTokenExpired()) {
    if (accessToken && isMfaPending(accessToken)) {
      if (MFA_PATHS.some((p) => location.pathname.startsWith(p))) {
        return <>{children}</>;
      }
      const target = mfaRedirectPath(accessToken);
      if (target) {
        return <Navigate to={target} replace />;
      }
    }
    const from = (location.state as { from?: Location })?.from?.pathname || "/";
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}
